export default "__VITE_ASSET__DYBEvqxI__";